import { useState } from "react";
import axios from "../../../axios";
import { useNavigate } from "react-router-dom";
import CoverDesignForm from "./CoverDesignForm";
import ErrorModal from "../../components/ErrorModal";
import handleApiError from "../../../utils/handleApiError";
import SuccessModal from "../../components/SuccessModal";

export default function CoverDesignCreatePage() {
    const [form, setForm] = useState({ name: "" });
    const [image, setImage] = useState(null);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append("name", form.name);
        if (image) data.append("image", image);

        try {
            await axios.post("/admin/cover-designs", data);
            setSuccess("Data berhasil ditambahkan!");
        } catch (err) {
            setError(handleApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <ErrorModal error={error} onClose={() => setError("")} />
            <SuccessModal
                message={success}
                onClose={() => {
                    setSuccess("");
                    navigate("/admin/cover-designs");
                }}
            />
            <CoverDesignForm
                form={form}
                setForm={setForm}
                image={image}
                setImage={setImage}
                onSubmit={handleSubmit}
                title="Tambah Cover Designs"
                buttonLabel="Simpan"
            />
        </>
    );
}
